module.exports = __webpack_public_path__ + "static/img/nav-4.43958af.png";


//////////////////
// WEBPACK FOOTER
// ./static/img/nav-4.png
// module id = 6rjc
// module chunks = 1